<template>
  <section class="tw-bg-white tw-py-24">
    <div class="tw-container tw-mx-auto tw-px-6">
      <div class="tw-text-center tw-mb-16">
        <h2 class="tw-text-4xl md:tw-text-5xl tw-font-bold tw-text-gray-900 tw-mb-4 tw-leading-tight">
          Why Your Event Platform Isn't Working
        </h2>
      </div>

      <div class="tw-max-w-6xl tw-mx-auto">
        <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-6 tw-mb-12">
          <!-- Card 1 -->
          <div class="tw-bg-gray-50 tw-p-6 tw-rounded-xl tw-border tw-border-gray-100">
            <div class="tw-w-12 tw-h-12 tw-bg-red-100 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mb-4">
              <svg class="tw-w-6 tw-h-6 tw-text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
            <h3 class="tw-text-lg tw-font-semibold tw-text-gray-900 tw-mb-2">Attendance Problem</h3>
            <p class="tw-text-gray-600 tw-text-sm tw-leading-relaxed">
              Attendees walk the floor aimlessly. Meetings don't happen.
            </p>
          </div>

          <!-- Card 2 -->
          <div class="tw-bg-gray-50 tw-p-6 tw-rounded-xl tw-border tw-border-gray-100">
            <div class="tw-w-12 tw-h-12 tw-bg-orange-100 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mb-4">
              <svg class="tw-w-6 tw-h-6 tw-text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h3 class="tw-text-lg tw-font-semibold tw-text-gray-900 tw-mb-2">Organizer Burden</h3>
            <p class="tw-text-gray-600 tw-text-sm tw-leading-relaxed">
              Generic platforms require weeks of setup and manual matching.
            </p>
          </div>

          <!-- Card 3 -->
          <div class="tw-bg-gray-50 tw-p-6 tw-rounded-xl tw-border tw-border-gray-100">
            <div class="tw-w-12 tw-h-12 tw-bg-yellow-100 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mb-4">
              <svg class="tw-w-6 tw-h-6 tw-text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h3 class="tw-text-lg tw-font-semibold tw-text-gray-900 tw-mb-2">Revenue Problem</h3>
            <p class="tw-text-gray-600 tw-text-sm tw-leading-relaxed">
              Low ROI for sponsors + low exhibitor satisfaction = low renewals.
            </p>
          </div>
        </div>

        <!-- Transition Message -->
        <div class="tw-text-center">
          <div class="tw-inline-block tw-bg-primary-50 tw-border tw-border-primary-200 tw-px-8 tw-py-4 tw-rounded-xl">
            <p class="tw-text-lg tw-font-semibold tw-text-primary-700">
              There's a better way. TopEshows changes the equation.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
